import { render, staticRenderFns } from "./PaymentPlan.vue?vue&type=template&id=50fbcff3&scoped=true&"
import script from "./PaymentPlan.vue?vue&type=script&lang=js&"
export * from "./PaymentPlan.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPlan.vue?vue&type=style&index=0&id=50fbcff3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fbcff3",
  null
  
)

export default component.exports